import FlexcarBrandmarkYuge from '@/icons/flexcar-brandmark-yuge';

export default function LowInventoryTile() {
  return (
    <div className="relative flex aspect-square h-[100%] w-full flex-1 flex-col justify-between rounded-[16px] bg-[linear-gradient(135deg,#71D9D5_-10.58%,#D2C6F7_80.75%,#F9DCDB_116.15%)] p-[24px]">
      <h3
        className="text-[26px] font-medium leading-[38px] text-flexcar-neutral100"
        style={{
          textShadow:
            '0px 5px 16px rgba(34, 37, 42, 0.05), 0px 5px 16px rgba(13, 0, 51, 0.08), 0px 0px 1.5px rgba(42, 0, 165, 0.25)',
        }}
      >
        Due to high demand, we have limited inventory.
      </h3>
      <h3 className="text-[22px] font-medium leading-[38px] text-flexcar-neutral100">
        Please check back soon if you don&apos;t see what you&apos;re looking for.
      </h3>
      <div className="absolute bottom-0 right-0">
        <FlexcarBrandmarkYuge />
      </div>
    </div>
  );
}
